import React, { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { scanReceipt, UPGRADE_URL } from "./aiAssist.js";
import { syncConfigured } from "./supabaseClient.js";

// "Scan receipt" for the Add expense form. Picks or takes a photo, asks Claude to read it, and hands the result to onResult
// so the form fields can be pre-filled. The person always reviews and saves it themselves.
export default function ReceiptScan({ categories, currency, session, onResult }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [upgrade, setUpgrade] = useState(false);

  function start() {
    setMsg(""); setUpgrade(false);
    if (!syncConfigured || !session) { setMsg("Sign in (Settings, then Account & sync) to scan receipts."); return; }
    input.current?.click();
  }

  async function onFile(e) {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true); setMsg(""); setUpgrade(false);
    try {
      const r = await scanReceipt(f, { categories });
      if (!r?.isReceipt) { setMsg("That doesn't look like a receipt. Try again with the whole receipt in view."); return; }
      onResult(r);
      const notes = [];
      if (!r.total) notes.push("Couldn't read the total, so enter it yourself.");
      if (r.currency && currency && r.currency !== currency) notes.push(`This receipt is in ${r.currency} but this profile uses ${currency}. The amount isn't converted.`);
      if (r.confidence === "low") notes.push("Low confidence: please double-check everything.");
      setMsg(notes.length ? notes.join(" ") : "Filled in from your receipt. Check it before saving.");
    } catch (err) {
      setMsg(err.message || "Couldn't scan that receipt.");
      setUpgrade(err.status === 402);
    } finally { setBusy(false); }
  }

  return (
    <div className="mb-4">
      <input ref={input} type="file" accept="image/*" onChange={onFile} className="hidden" />
      <button onClick={start} disabled={busy} className="w-full flex items-center justify-center gap-2 bg-card rounded-xl py-2.5 text-sm font-medium disabled:opacity-60">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <Camera size={15} className="text-brass" />}
        {busy ? "Reading receipt…" : "Scan receipt"}
      </button>
      {msg && <div className="text-xs text-ivory-dim mt-2 leading-relaxed">{msg}</div>}
      {upgrade && UPGRADE_URL && <a href={UPGRADE_URL} target="_blank" rel="noopener noreferrer" className="inline-block text-xs text-brass font-medium underline mt-1">See the paid plan</a>}
    </div>
  );
}
